"use client";

import { SwitchCamera } from "lucide-react";
import { RecordButton } from "./record-button";

type RecordingPhase = "ready" | "countdown" | "recording" | "processing";

type Props = {
  phase: RecordingPhase;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onSwitchCamera?: () => void;
  disabled?: boolean;
  progress: number;
};

/**
 * Controls for camera recording with custom record button.
 */
export const CreatorCameraControls = ({
  phase,
  onStartRecording,
  onStopRecording,
  onSwitchCamera,
  disabled,
  progress,
}: Props) => {
  const onClick = () => {
    if (phase === "ready") {
      onStartRecording();
    } else if (phase === "recording") {
      onStopRecording();
    }
  };

  const isDisabled = disabled || phase === "processing";

  return (
    <div className="relative flex w-full items-center justify-center">
      <RecordButton
        state={phase}
        onClick={onClick}
        disabled={isDisabled}
        progress={progress}
      />
      {phase === "ready" && onSwitchCamera && (
        <button
          onClick={onSwitchCamera}
          disabled={disabled}
          className="absolute right-4 inline-flex cursor-pointer items-center justify-center rounded-full p-2 text-white transition-opacity hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-50"
          aria-label="Switch camera"
          type="button"
        >
          <SwitchCamera className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
